import { render, staticRenderFns } from "./FaqEdit.vue?vue&type=template&id=471afd2c&"
import script from "./FaqEdit.vue?vue&type=script&lang=js&"
export * from "./FaqEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports